// MM: there is just no way I could remove the import cycle due to the way localsync has to be created
// with defined argument that I can't tweak to pass them dispatch via curry or such
/* eslint-disable import/no-cycle */
/* ------------------------------------------- */
/*   Redux Root Reducer
/*   The Root reducer combines the different reducers responsible for updating specific bits of data in the state
/* ------------------------------------------- */

import { combineReducers } from 'redux';
import { authReducer } from 'AppSrc/core/auth/auth-reducer';
import { mainFormReducer } from 'AppSrc/core/reducers/reducer-main-form';
import { editFormReducer } from 'AppSrc/core/reducers/reducer-edit-form';
import { approverGroupsReducer } from 'AppSrc/core/approvers/approver-groups-reducer';
import { coordinatorGroupsReducer } from 'AppSrc/core/coordinators/coordinator-groups-reducer';
import { crqReducer } from 'AppSrc/core/crq/crq-reducer';
import { crqListReducer } from 'AppSrc/core/crq/crq-list-reducer';
import { workInfoItemReducer } from 'AppSrc/core/work-info-items/work-info-item-reducer';
import { pouReducer } from 'AppSrc/core/pou/pou-reducer';
import { relationshipsReducer } from 'AppSrc/core/relationships/relationships-reducer';
import { sponsorReducer } from 'AppSrc/core/sponsor/sponsor-reducer';
import { typeaheadListReducer } from 'AppSrc/core/reducers/reducer-typeahead-list';
import { displayOptionsReducer } from 'AppSrc/core/components/forms/form-base-components/redux/display-options/reducer-display-options';
import { errorAlertReducer } from 'AppSrc/core/reducers/reducer-error-alert';
import { outageBannerReducer } from 'AppSrc/core/components/outage-banner/outage-reducer';
import { individualApproverReducer } from 'AppSrc/core/approvers/approver-individual-reducer';
import { remedyReferenceCrqReducer } from 'AppSrc/core/reducers/reducer-remedy-ref-crq-data';

const rootReducer = combineReducers({
  approverGroups: approverGroupsReducer,
  auth: authReducer,
  coordinatorGroups: coordinatorGroupsReducer,
  crq: crqReducer,
  crqList: crqListReducer,
  displayOptions: displayOptionsReducer,
  editForm: editFormReducer,
  errorAlert: errorAlertReducer,
  mainForm: mainFormReducer,
  pou: pouReducer,
  relationships: relationshipsReducer,
  sponsor: sponsorReducer,
  typeaheadList: typeaheadListReducer,
  workInfoItem: workInfoItemReducer,
  outageBanner: outageBannerReducer,
  individualApproverList: individualApproverReducer,
  remedyReferenceCrq: remedyReferenceCrqReducer,
});

export { rootReducer };
